module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markers-table"
  }, [_c('div', {
    staticClass: "row header hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.targeted_groups')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.start_date')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.end_date')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.records_count')))])]), _vm._v(" "), _vm._l((_vm.markers), function(marker) {
    return _c('marker-row', {
      key: marker.id,
      staticClass: "row",
      attrs: {
        "marker": marker
      },
      on: {
        "trash": _vm.deleteMarker
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7c9deba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markersList/MarkersTable.vue
// module id = 1070
// module chunks = 1